// ClientOverview.jsx
import React, { useEffect, useMemo, useState } from "react";
import { onSnapshot, doc, collection } from "firebase/firestore";
import { auth, db } from "../firebase";
import { signOut } from "firebase/auth";
import { Navigate } from "react-router-dom";

export default function ClientPanel() {
  const [userAcc, setUserAcc] = useState(null);
  const [groups, setGroups] = useState([]);      // array
  const [locations, setLocations] = useState([]); // array

  // === POBIERANIE KONTA UŻYTKOWNIKA ===
  useEffect(() => {
    if (!auth?.currentUser?.uid) return;
    const unsub = onSnapshot(doc(db, "users2026", auth.currentUser.uid), (snap) => {
      setUserAcc(snap.data() || null);
    });
    return () => unsub && unsub();
  }, []);

    const handleLogout = async () => {
      try {
        await signOut(auth);
        Navigate('/');
      } catch (e) {
        console.error('Błąd podczas wylogowania:', e);
      }
    };

  // === POBIERANIE GRUP (jedna mapa dokumentu groups) ===
  useEffect(() => {
    const TARGET_ID = "SPdqELFz2ovWSn8eFyws";
    const ref = doc(db, "groups", TARGET_ID);
    const unsub = onSnapshot(ref, (snapshot) => {
      if (!snapshot.exists()) return setGroups([]);
      const data = snapshot.data() || {};
      const arr = Object.values(data).filter(Boolean);
      setGroups(arr);
    }, () => setGroups([]));
    return () => unsub && unsub();
  }, []);

  // === POBIERANIE LOKALIZACJI (wiele dokumentów) ===
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "locations"), (snapshot) => {
      // flatten wszystkich doców (każdy doc jest mapą -> values)
      const flat = snapshot.docs.flatMap((d) => Object.values(d.data() || {}));
      setLocations(flat);
    });
    return () => unsub && unsub();
  }, []);

  // === POMOCNICZE ===
  const weekDayPL = (num) =>
    ({1:"Poniedziałek",2:"Wtorek",3:"Środa",4:"Czwartek",5:"Piątek",6:"Sobota",7:"Niedziela"}[num] || "");

  const locationsIndex = useMemo(() => {
    const idx = new Map();
    (Array.isArray(locations) ? locations : []).forEach(l => idx.set(l?.id, l));
    return idx;
  }, [locations]);

  const groupsIndex = useMemo(() => {
    const idx = new Map();
    (Array.isArray(groups) ? groups : []).forEach(g => idx.set(g?.id, g));
    return idx;
  }, [groups]);

  const getLocationName = (id) => locationsIndex.get(id)?.name || "Nieznana lokalizacja";

  const formatGroup = (gid) => {
    const g = groupsIndex.get(gid);
    if (!g) return `Grupa: ${gid}`;
    const loc = getLocationName(g?.location_id);
    const d = g?.days?.[0];
    const when = d?.custom_name
      ? d.custom_name
      : `${weekDayPL(d?.weekDay)} • ${d?.startTime}–${d?.endTime}`;
    return `${loc} • ${when} • ${g?.type || ""}`.trim();
  };

  const subUsers = userAcc?.subUsers || {};
  const subKeys = Object.keys(subUsers);

  const parent = userAcc?.parent;

  return (
    userAcc && (Object.values(subUsers).some(su => su?.toVerificate === true)) ? (
        // ======= EKRAN WERYFIKACJI =======
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:20,padding:"20px 16px",background:"#F5F7FB",minHeight:"100vh", justifyContent: "flex-start"}}>
          <div style={({width: "min(720px, 92vw)", borderRadius: "18px", padding: "28px", display: "flex", flexDirection: "column", alignItems: "center"})}>
            <div style={({width: "86px", height: "86px", borderRadius: "50%", display: "grid", placeItems: "center", background: "linear-gradient(135deg, #111827 0%, #374151 100%)", boxShadow: "0 10px 22px rgba(17,24,39,0.25)", marginBottom: "14px"})}>
              <svg width="42" height="42" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="9" stroke="white" strokeWidth="2.5"/>
                <path d="M12 7v5l3 2" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 style={({fontSize: "30px", color: "rgb(22,22,22)", textAlign: "center", margin: "0 0 8px 0", fontWeight: 700})}>Twoje konto jest w trakcie weryfikacji</h3>
            <h3 style={({fontSize: "16px", color: "rgb(80,80,80)", textAlign: "center", fontWeight: "normal", margin: "0 0 12px 0"})}>
              Dziękujemy za rejestrację! Weryfikacja może potrwać do <span style={({fontWeight: 600})}>48 godzin</span> od założenia konta.
            </h3>
            <hr style={({height: "1px", border: "none", width: "100%", background: "linear-gradient(90deg, rgba(0,0,0,0), rgba(0,0,0,0.08), rgba(0,0,0,0))", margin: "10px 0 14px 0"})} />
            <h3 style={({fontSize: "15px", color: "rgb(55,55,55)", textAlign: "center", fontWeight: "normal", margin: "0 0 6px 0"})}>
              Po zakończeniu weryfikacji wyślemy na Twój e-mail <span style={({fontWeight: 600})}>fakturę do opłaty</span>.
            </h3>
            <h3 style={({fontSize: "15px", color: "rgb(55,55,55)", textAlign: "center", fontWeight: "normal", margin: "0 0 6px 0"})}>
              Po zalogowaniu <span style={({fontWeight: 600})}>po weryfikacji konta</span> podpiszesz <span style={({fontWeight: 600})}>dokumenty online</span> bezpośrednio tutaj.
            </h3>
            <h3 style={({fontSize: "15px", color: "rgb(55,55,55)", textAlign: "center", fontWeight: "normal", margin: "0 0 10px 0"})}>
              Czas weryfikacji zależy od bieżącego obłożenia — prosimy o chwilę cierpliwości.
            </h3>
            <h3 style={({fontSize: "14px", color: "rgb(110,110,110)", textAlign: "center", fontWeight: "normal", margin: "6px 0 4px 0"})}>
              Nie widzisz wiadomości? Sprawdź folder <span style={({fontWeight: 600})}>SPAM/Oferty</span>.
            </h3>
            <h3 style={({fontSize: "14px", color: "rgb(110,110,110)", textAlign: "center", fontWeight: "normal", margin: "0 0 16px 0"})}>
              tel. <span style={({fontWeight: 600})}>505&nbsp;376&nbsp;552</span> · e-mail <span style={({fontWeight: 600})}>4starsdanceaerialstudio@gmail.com</span>
            </h3>
            <h3 style={({fontSize: "15px", color: "#0045C7", fontWeight: "bold", textAlign: "center", margin: "4px 0 0 0", cursor: "pointer"})} onClick={() => handleLogout()}>
              Wyloguj
            </h3>
          </div>
        </div>
      ) : (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:20,padding:"20px 16px",background:"#F5F7FB",minHeight:"100vh", justifyContent: "flex-start"}}>
      {/* NAGŁÓWEK */}
      <div style={{width:"100%",maxWidth:1050,display:"flex",justifyContent:"center",alignItems:"center"}}>
        <h2 style={{margin:0,fontSize:24,color:"#111"}}>Panel klienta</h2>
      </div>

      {/* KARTA RODZICA */}
      <div style={{width:"90%",maxWidth:1020,background:"#fff",border:"1px solid #e8ebf2",borderRadius:14,padding:16,boxShadow:"0 6px 20px rgba(17,24,39,.06)"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8}}>
          <div style={iconCircle("#0A66FF")} aria-hidden>
            {personSvg("#fff")}
          </div>
          <div>
            <div style={{fontSize:16,fontWeight:700,color:"#111"}}>Dane rodzica / opiekuna</div>
            <div style={{fontSize:12,color:"#666"}}>informacje kontaktowe do płatności i komunikacji</div>
          </div>
        </div>

        <div style={grid2}>
          <InfoRow label="Imię i nazwisko" value={parent?.displayName || "—"} />
          <InfoRow label="E-mail" value={userAcc?.email || "—"} />
          <InfoRow label="Telefon" value={parent?.phone || "—"} />
        </div>
      </div>

      {/* LISTA UCZESTNIKÓW */}
      <div style={{width:"90%",maxWidth:1020,background:"#fff",border:"1px solid #e8ebf2",borderRadius:14,padding:16,boxShadow:"0 6px 20px rgba(17,24,39,.06)"}}>
        {subKeys.length === 0 && (
          <div style={{color:"#444"}}>Brak uczestników na koncie.</div>
        )}

        {subKeys.map((k) => {
          const u = subUsers[k];
          const docs = u?.docs || {};
          const required = Array.isArray(docs?.required) ? docs.required : Object.keys(docs || {});
          const signedCount = required.filter(key => docs?.[key]?.signed).length;
          const price = docs?.contract?.price;
          const groupsNo = docs?.contract?.groups;
          const type = docs?.contract?.type;

          return (
            <div key={k} style={userCard}>
              {/* Nagłówek użytkownika */}
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10, width: "100%"}}>
                <div style={iconCircle("#0A66FF")} aria-hidden>
                  {personSvg("#fff")}
                </div>
                <div style={{display:"flex",flexDirection:"column"}}>
                  <div style={{fontWeight:700,color:"#111"}}>{u?.displayName || "Uczestnik"}</div>
                  <div style={{fontSize:12,color:"#666"}}>
                    {u?.adult ? "Osoba dorosła" : "Nieletni(a)"}
                  </div>
                </div>
              </div>

              {/* Dane szczegółowe */}
              <div style={grid2}>
                <InfoRow label="PESEL" value={u?.pesel || "—"} />
                <InfoRow label="Data urodzenia" value={u?.dateOfBirth || "—"} />
                <InfoRow label="Status dokumentów" value={`${signedCount}/${required.length} podpisane`} />
                <InfoRow label="Liczba grup (umowa)" value={groupsNo ?? "—"} />
                <InfoRow label="Cena miesięczna" value={price != null ? `${price} PLN` : "—"} />
              </div>

              {/* Grupy */}
              <div style={{marginTop:10}}>
                <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:6}}>Grupy uczestnika</div>
                {Array.isArray(u?.groups) && u.groups.length > 0 ? (
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    {u.groups.map((gid) => (
                      <div key={gid} style={pill}>
                        {formatGroup(gid)}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{fontSize:12,color:"#666"}}>Brak przypisanych grup.</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {/* Informacja dla klienta */}
        <div style={{width:"90%",maxWidth:1020}}>
            <div
                style={{
                marginTop:16,
                background:"#111827",
                color:"#fff",
                borderRadius:12,
                padding:"14px 16px",
                }}
            >
                <div style={{fontWeight:500, fontSize:14, marginBottom:6}}>Ważne informacje!</div>
                <div style={{fontSize:13, lineHeight:1.5}}>
                Faktury za zajęcia znajdziesz w wiadomości e-mail od Stripe na swojej poczcie,
                a dokumentację w zakładce „Dokumentacja”.
                </div>
            </div>
        </div>

    </div>
  ));
}

/* —————————————————— WSPÓLNE MAŁE KOMPONENTY —————————————————— */

function InfoRow({ label, value }) {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:4}}>
      <div style={{fontSize:11,color:"#6b7280"}}>{label}</div>
      <div style={{fontSize:13,color:"#111"}}>{(value ?? "") === "" ? "—" : value}</div>
    </div>
  );
}

const iconCircle = (bg) => ({
  width:40, height:40, borderRadius:12, display:"grid", placeItems:"center",
  background:bg
});

const personSvg = (fill="#fff") => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Z" fill={fill}/>
    <path d="M4 21a8 8 0 0 1 16 0" fill="none" stroke={fill} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const grid2 = {
  display:"grid",
  gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",
  gap:12
};

const userCard = {
  minWidth:300,
  maxWidth: 1050,
  width: "100%",
  background:"#fff",
  borderRadius:14,
  marginBottom: "20px",
  paddingTop: "10px"
};

const pill = {
  display:"inline-flex",
  alignItems:"center",
  padding:"6px 10px",
  background:"#F0F6FF",
  color:"#0A66FF",
  fontSize:12,
  borderRadius:999
};
